import axios from 'axios';

const api = axios.create({
 //baseURL:"http://192.168.29.251:9998" 
  baseURL:"https://api.rndsan.com/"
});

export default api;